// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1067":"4d48c8212c64db49","3342":"bd8e286ddddde858","3804":"6197ca4b0467346f","3991":"93cdc9cf2393f896","4088":"5ad757b735da5a40"}[chunkId] + ".js";
};